// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"0622e50b","551":"5643f081","603":"3364d261","673":"0622e50b","790":"336806c3"}[chunkId] + ".chunk.css";
};